import { EMPTY } from '@shared/utils/strings';
export function formatSurface(surface, unit = 'm') {
    return `${surface}${unit}²`;
}
export function formatOptionalSurface(surface, unit = 'm', defaultString = EMPTY) {
    return surface === undefined || surface === null ? defaultString : formatSurface(surface, unit);
}
